import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { ThemeContext } from '@wix/da-react-context/pkg/ThemeContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import { BiData } from '@wix/da-bi/pkg/events';
import { setTheme, setThemeSkin, toggleTheme } from '../../../../publicSession/actions';
import ThemeSwitcherButtons from '../../../_partials/UserMenu/UserMenuDesktop/_partials/ThemeSwitcherButtons';
import ThemeToggle from '../../../_partials/ThemeToggle/ThemeToggle';
import userMenuStyles from '../UserMenuMobile/UserMenuMobile.scss';
export function useThemeSwitcherItem() {
    const { theme, themeSkin } = useContext(SessionContext);
    const dispatchSetTheme = useAction(setTheme);
    const dispatchSetThemeSkin = useAction(setThemeSkin);
    return {
        key: 'theme-switcher',
        label: /*#__PURE__*/ React.createElement(ThemeSwitcherButtons, {
            theme: theme,
            themeSkin: themeSkin,
            setTheme: dispatchSetTheme,
            setThemeSkin: dispatchSetThemeSkin
        })
    };
}
/**
 * Instead of three options, this version of the theme switcher is a pill-style toggle. It switches between light and dark theme.
 */ export function useThemeToggleItem() {
    const theme = useContext(ThemeContext);
    const { t } = useTranslation();
    const dispatchToggleTheme = useAction(toggleTheme);
    return {
        key: 'theme-toggle',
        label: t('siteHeaderMobile.userMenu.mode'),
        suffix: /*#__PURE__*/ React.createElement(ThemeToggle, {
            toggleTheme: dispatchToggleTheme,
            className: userMenuStyles['theme-toggle']
        }),
        biData: BiData({
            evid: 702,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: theme === 'light' ? 'dark' : 'light'
        })
    };
}
